// extracted by mini-css-extract-plugin
export default {"component":"i9YX6Q","wrapper":"AcvmAX","old-price--xl":"DSGAoX","old-price--l":"neWrpy","old-price--m":"BgXRFw","old-price--s":"F7nVUr","discount":"EtETuO","discount--s":"MKHgct"};